/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { useShouldRemoveAds } from 'lib/subscriptionUtils';
import Ad from './index';

/**
 * Wrapper component for topbanner ads that handles subscription-based ad hiding.
 * When user is logged in with subscription feature flag enabled, returns null.
 * Otherwise renders the ad in a desktop-only wrapper div.
 *
 * @param {object} props - Component props
 * @returns {JSX.Element|null} Ad wrapper or null if should hide ads
 */
const TopBannerWrapper = (props) => {
  const shouldRemoveAds = useShouldRemoveAds();

  return shouldRemoveAds ? null : (
    <div className="dn db-m">
      <Ad
        slot="topbanner"
        offsetViewport={100}
        pkgClassName="pkg-ad ad ad--centered"
        refreshInterval={0}
        {...props}
      />
    </div>
  );
};

TopBannerWrapper.propTypes = {
  packageId: PropTypes.string,
  manuallyCuratedAd: PropTypes.bool,
};

export { TopBannerWrapper };
